import { makeSelectors } from '@utils/css';

const toggle = "_35stg8yolt";
const box = "_35sbpe0clx";
const content = "_35sclarjfd";
const toggleIcon = "_35stjp3afx";
const icon = "_35si1uuopak";
makeSelectors({
  box,
  content
});

export { box, content, icon, toggle, toggleIcon };
import "./_media-box.style.linaria.module.css";
//# sourceMappingURL=_media-box.style.js.map
